export const AUTH_SESSION_EXPIRED = 'AUTH_SESSION_EXPIRED';

export const SESSION_EXPIRED_REASON = 'session-expired';
export const SESSION_EXPIRED_STORAGE_KEY = 'admin-session-expired-message';

export const SESSION_EXPIRED_MESSAGE =
    'Время вашей сессии закончилось. Для безопасности войдите снова, чтобы продолжить работу.';

const stringifyValue = (value) => {
    if (value === null || value === undefined) return '';

    if (typeof value === 'string') return value;

    try {
        return JSON.stringify(value);
    } catch (error) {
        return String(value);
    }
};

const getErrorSearchText = (error) => {
    const values = [
        error?.response?.data?.message,
        error?.response?.data?.error,
        error?.response?.data?.code,
        error?.response?.data?.name,
        error?.code,
        error?.name,
        error?.message,
    ];

    return values
        .map(stringifyValue)
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .replace(/[_-]+/g, ' ');
};

export const isJwtExpiredError = (error) => {
    const searchText = getErrorSearchText(error);

    if (!searchText) return false;

    return [
        'jwt expired',
        'token expired',
        'token has expired',
        'expired token',
        'token expired error',
        'срок действия токена истек',
        'срок действия токена истёк',
    ].some((marker) => searchText.includes(marker));
};

export const isAuthEntryRequest = (url) => {
    const prepared = String(url || '');

    return /\/admin\/(?:signin|signup)(?:[/?#]|$)/i.test(prepared);
};

export const clearStoredAuthData = () => {
    if (typeof window === 'undefined') return;

    try {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');
    } catch (error) {
        // Нельзя блокировать выход, если хранилище браузера недоступно.
    }

    window.__ME_ID__ = null;

    try {
        const socket = window.__ADMIN_SOCKET__;

        if (socket) {
            socket.auth = {
                ...(socket.auth || {}),
                token: undefined,
            };
            socket.disconnect();
        }
    } catch (error) {
        // Ошибка сокета не должна мешать очистке просроченной сессии.
    }

    try {
        const callsSocket = window.__CALLS_SOCKET__;
        if (callsSocket) {
            callsSocket.auth = { ...(callsSocket.auth || {}), token: undefined };
            callsSocket.disconnect();
        }
    } catch (error) {
        // Звонковый сокет не должен мешать очистке сессии.
    }
};

export const saveSessionExpiredNotice = (
    message = SESSION_EXPIRED_MESSAGE
) => {
    if (typeof window === 'undefined') return;

    try {
        window.sessionStorage.setItem(
            SESSION_EXPIRED_STORAGE_KEY,
            String(message || SESSION_EXPIRED_MESSAGE)
        );
    } catch (error) {
        // В URL также передаётся reason, поэтому сообщение не потеряется.
    }
};

export const consumeSessionExpiredNotice = () => {
    if (typeof window === 'undefined') return '';

    try {
        const message =
            window.sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY) || '';

        window.sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);

        return message;
    } catch (error) {
        return '';
    }
};
